import React from "react";
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import Tickets from "../TicketsCustom"
import TicketAdvanced from "../TicketsAdvanced";

function TicketResponsiveContainer () {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    
    // Fallback para iOS - sempre usar versão desktop se houver erro
    try {
        if (isDesktop) {
            return <Tickets />;    
        }
        return <TicketAdvanced />
    } catch (error) {
        console.error('Error in TicketResponsiveContainer:', error);
        // Fallback para desktop em caso de erro
        return <Tickets />;
    }
}

export default TicketResponsiveContainer;